import React from 'react';
import { useTypedSelector } from 'Store/_Store';

const USSD_PREFIX = '*820*11*';

const Ussd = () => {
    const { business } = useTypedSelector((state) => state._auth);
    const ussdCode = business.ussd_id ? `${USSD_PREFIX}${business.ussd_id}#` : null;

    return (
        <React.Fragment>
            <div className="bg-white rounded-xl p-6 space-y-6">
                <div>
                    <div className="font-semibold text-base">USSD</div>
                    <div className="text-gray-500 text-sm mt-0.5">
                        Accept payments from customers dialing your USSD code.
                    </div>
                </div>

                <div className="flex items-center gap-3 p-4 rounded-lg bg-gray-50 border border-gray-100">
                    <div className="text-sm">
                        <div className="text-gray-500">Your USSD code</div>
                        <div className="font-semibold text-xl mt-1 tracking-wide">
                            {ussdCode ?? '—'}
                        </div>
                        <div className="text-gray-400 text-xs mt-1">
                            Merchant ID: {business.ussd_id ?? '—'}
                        </div>
                    </div>
                </div>

                <div className="text-sm text-gray-500">
                    Share this code with your customers so they can complete USSD payments to your business. Contact support if you need this changed.
                </div>
            </div>
        </React.Fragment>
    );
};

export default Ussd;
